import { useLocation } from "wouter";
import e from './style.module.css';

export const Error = () => {
  const [, setLocation] = useLocation();

  return (
    <section className={e['ctn-404-page']}>
      <h1>404</h1>
      <h4>Página no encontrada.</h4>
      <a className="btn btn-white" onClick={() => setLocation("/")}>
        <i className="bi bi-house-door-fill"></i> Volver al inicio
      </a>
    </section>
  )
}
